import type { AxiosInstance } from 'axios';

export class ProxiesClient {
  constructor(private authenticatedClient: AxiosInstance) {}
}
